<template>
  <section class="main-modal">
    <div
      :class="[
        'main-modal__inner',
        { 'main-modal__inner--has-radius': true },
      ]"
      :style="{ height, width }"
    >
      <div
        ref="scrollWrapper"
        v-if="hasScroll"
        class="scrollable-content-wrapper"
      >
        <div class="scroll-effect-top-bottom" :class="{ 'hide-top-effect': hideTopScrollEffect }">
          <div class="scroll-effect-left-right">
            <div ref="innerScrollWrapper" class="inner-scroll-wrapper" @scroll.passive="updateContainerScroll($event)">
              <div>
                <h3 class="main-modal__title">{{ title }}</h3>
                <SvgClose
                  class="main-modal__close"
                  @click="$emit('close-modal', false)"
                />
                <div class="inner-scroll-wrapper-spacer" ref="innerScrollWrapperSpacer">
                  <slot name="modal-slot" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-else>
        <h3 class="main-modal__title">{{ title }}</h3>
        <SvgClose
          class="main-modal__close"
          @click="$emit('close-modal', false)"
        />
        <slot name="modal-slot" />
      </template>
    </div>
  </section>
</template>
<script>
import scrollShadowMixin from '@/mixins/scrollShadowMixin';
import eventHub from '../eventHub';

export default {
  name: 'Modal',

  mixins: [scrollShadowMixin],

  components: {
    SvgClose: () => import('@/assets/svgs/close.svg?inline'),
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    hasTitle: {
      type: Boolean,
      default: true,
    },
    hasRadius: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '100%',
    },
    width: {
      type: String,
      default: '100%',
    },
    overflow: {
      type: String,
      default: 'auto',
    },
    hideTopScrollEffect: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.resetScroll(document.body);
    this.setupResizeObserver(this.$refs.innerScrollWrapper);
    this.forceContentRedraw(this.$refs.scrollWrapper, this.$refs.innerScrollWrapper);
    this.$emit('open-modal')
  },

  unmounted() {
    this.tearDownResizeObserver(this.$refs.innerScrollWrapper);
  },

  methods: {
    updateContainerScroll($event) {
      eventHub.$emit('hide-tooltip');
      this.updateScrollEffects($event);
    },
  },

  computed: {
    hasScroll() {
      return this.overflow && this.overflow !== 'hidden';
    },
  },
};
</script>
<style lang="scss" scoped>
.main-modal {
  padding: rem(40) rem(55);
  background: rgba($overlay, 0.9);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  &__inner {
    background: $white;
    border: 1px solid $border;
    position: relative;

    &--has-radius {
      border-radius: rem(7);
      overflow: hidden;
    }
  }

  &__title {
    position: absolute;
    top: 0;
    left: rem(45);
    right: rem(45);
    z-index: 1;
    margin: 0;
    padding: rem(30) 0 rem(20) 0;
    color: $globalSideNavHeaderColour;
    font-size: rem(25);
    font-weight: $font-regular;
    line-height: 1.25;
    background: #fff;
  }

  &__close {
    width: rem(36);
    position: absolute;
    right: rem(14);
    top: rem(14);
    cursor: pointer;
    z-index: 1;
  }
}

.scrollable-content-wrapper {
  @include scrollable-with-shadow();
  height: 100%;

  .scroll-effect-top-bottom:before {
    top: rem(80);
  }

  .hide-top-effect:before {
    display: none;
  }
}

.inner-scroll-wrapper {
  display: flex;
  overflow: auto;
  width: 100%;
  height: 100%;
  padding: 0 rem(45);

  > * {
    width: 100%;
  }

  &-spacer {
    padding: rem(81) 0 rem(45) 0;
  }
}

</style>
